import './App.css';
import RouteList from './Routes/RouteList';
function App() {
  return (
    <>
      <RouteList />
    </>
  );
}

export default App;
